import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const isSidebarOpen = atomWithStorage("sidebarExpanded", false, {
  ...createJSONStorage(() => localStorage),
  delayInit: true,
});
